import axios from "../axiosInstance";
import store from "@/store";
import { handleApiResponse } from "../utils";

export const createCustomGroup = requestBody =>
 handleApiResponse(() => axios.post(`/fft/v2/ingredient-list/custom-group`, requestBody), "Custom group created successfully");

export const updateCustomGroup = (customGroupId, requestBody) =>
 handleApiResponse(() => axios.put(`/fft/v2/ingredient-list/custom-group/${customGroupId}`, requestBody), "Custom group updated successfully");

export const deleteCustomGroup = customGroupId =>
 handleApiResponse(() => axios.delete(`/fft/v2/ingredient-list/custom-group/${customGroupId}`), "Custom group deleted successfully");
